const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const STORAGE_KEY = "ahq_utm";

export function captureUtm() {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v.slice(0, 120);
  });
  if (Object.keys(found).length) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}
